<template>
  <div class="userList electricityBill">
    <div class="content">
      <div class="userList-top">
        <div class="user-left">
          <div v-for="item in statusList" :key="item.id" :class="[{'active': item.id == chosenIndex}]"
            @click="chosenIndex = item.id">{{item.name}}</div>
        </div>
        <div class="btns">
          <div class="specification-tips">
            <i class="el-icon-question"></i>
            <span>导入用户列表请使用规范的Excl格式</span>
            <span class="view-btn" @click="dialogExcelRu = true">查看</span>
          </div>

          <el-upload action="" :show-file-list="false" :auto-upload="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            list-type="picture-card" :on-change="saveExcel_fn">
            <el-button type="primary" size="mini" style="margin-left:15px" :disabled='chosenIndex == "0"'>导入</el-button>
          </el-upload>

          <el-button type="primary" size="mini" @click="dialogExcel = true"
            :disabled='chosenIndex == "0"'>导出</el-button>
          <!-- <el-button type="danger" size="mini" plain @click="batchDel_fn">批量删除</el-button> -->
          <el-button type="primary" size="mini" @click="add_ed" :disabled='chosenIndex == "0"'
            class="last-el-button">新增</el-button>
        </div>
        <div :class="['line',{'active':chosenIndex=='0'}]"></div>
      </div>
      <div class="search">
        <el-form ref="form" :model="form" label-width="80px" size="medium" style="display: flex;width: auto;">
          <el-form-item label="姓名:">
            <el-input v-model="form.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="登录名:">
            <el-input v-model="form.userCode" placeholder="请输入登录名"></el-input>
          </el-form-item>
          <el-form-item label="证件号:">
            <el-input v-model="form.certificateNum" placeholder="请输入证件号"></el-input>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="身份证:">
            <el-input v-model="form.identityCard" placeholder="请输入身份证"></el-input>
          </el-form-item>
        </el-form>

        <el-button type="primary" @click="search" plain class="search-btn">查询</el-button>
      </div>
      <div class="userList-table" :style="{'height':heights+'px'}">
        <!-- @selection-change="handleSelectionChange" -->
        <el-table :data="tableData" v-loading="loading" style="width: 100%" :max-height="heights"
          @expand-change="openmf">
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <!-- <el-table-column
                        type="selection"
                        width="48"
                        
                        >
                    </el-table-column> -->
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-table :data="scope.row.children" header-row-class-name="tableNest" style="padding: 5px;
              padding-right: 0;
              padding-bottom: 0;
              padding-left: 44px;background: #f5f8fa;" v-if="update">
                <template slot="empty">
                  <span class="noData">
                    <img src="../../assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column prop="gender" label="性别" width="150" align="right"> </el-table-column>
                <el-table-column prop="dorm" label="宿舍" width="220"> </el-table-column>
                <el-table-column prop="qq" label="QQ" width="280"> </el-table-column>
                <el-table-column prop="mailAddress" label="邮箱" width="280"> </el-table-column>
                <el-table-column prop="department" label="系别" width="280"> </el-table-column>
                <el-table-column prop="specialty" label="专业" width="280"> </el-table-column>
                <el-table-column prop="classGrade" label="班级"> </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="userCode" label="登录名" min-width="200"> </el-table-column>
          <el-table-column prop="password" label="密码" min-width="130"> </el-table-column>
          <el-table-column prop="userName" label="姓名" min-width="136"> </el-table-column>
          <el-table-column prop="certificateNum" label="证件号" min-width="136"> </el-table-column>
          <el-table-column prop="phone" label="手机号" min-width="120"> </el-table-column>
          <el-table-column prop="iccard" label="IC卡" min-width="136"> </el-table-column>
          <el-table-column prop="roleType" label="角色类型" min-width="126"> </el-table-column>
          <el-table-column prop="identityCard" label="身份证" min-width="200"> </el-table-column>
          <el-table-column label="操作" align="center" min-width="120">
            <template #default="{row}">
              <span class="buttoned_box" v-show="chosenIndex == 1">
                <div @click="edit_ed(row,0)" class="mr-20">
                  <el-tooltip class="item" effect="dark" :content="row.iccard?'换绑':'绑定'" placement="top">
                    <elIconBtn btnType='binding'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="edit_ed(row,1)" class="mr-20">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                    <elIconBtn btnType='edit'></elIconBtn>
                  </el-tooltip>
                </div>
                <div @click="del_fn(row)">
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <elIconBtn btnType='del'></elIconBtn>
                  </el-tooltip>
                </div>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          background :page-sizes="[10, 20, 30, 40, 50]" :page-size="10" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>

      <downloadTable ref="downloadTable"></downloadTable>
    </div>

    <!-- 新增修改 -->

    <el-dialog width="35%" v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false'
      :visible.sync="dialogVisible">
      <div class="dialog-form">
        <el-form :model="temp" ref="temp" :rules="rules" style="width: 80%;height: 50px;padding-top: 10px;">
          <el-form-item label="登录名:" prop="userCode" v-show="iccardFlag == 1">
            <el-input v-model="temp.userCode"></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password" v-show="iccardFlag == 1">
            <el-input v-model="password" disabled placeholder="初始密码为身份证后六位"></el-input>
          </el-form-item>
          <el-form-item label="姓名:" prop="userName" v-show="iccardFlag == 1">
            <el-input v-model="temp.userName"></el-input>
          </el-form-item>
          <el-form-item label="IC卡:" prop="iccard" v-show="iccardFlag == 0">
            <el-input v-model="temp.iccard" @blur='iccardBlur_fn'></el-input>
          </el-form-item>
          <el-form-item label="证件号:" prop="certificateNum" v-show="iccardFlag == 1">
            <el-input v-model="temp.certificateNum"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="phone" v-show="iccardFlag == 1">
            <el-input v-model="temp.phone"></el-input>
          </el-form-item>

          <el-form-item label="角色类型:" prop="roleTypeId" v-show="iccardFlag == 1">
            <el-select v-model="temp.roleTypeId" placeholder="请选择" @change="roleSelect">
              <el-option v-for="item in roleOptions" :key="item.id" :label="item.roleName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证:" prop="identityCard" v-show="iccardFlag == 1">
            <el-input v-model="temp.identityCard" style="" @blur='blur_fn'></el-input>
          </el-form-item>
        </el-form>
        <el-form :model="temp2" ref="temp2" :rules="rules" style="width: 80%;height: 430px;padding-top: 10px;"
          v-show="iccardFlag == 1">
          <el-form-item label="性别:" prop="gender">
            <el-select v-model="temp2.gender" placeholder="请选择">
              <el-option v-for="item in sexList" :key="item.id" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="宿舍:" prop="dorm">
            <el-input v-model="temp2.dorm"></el-input>
          </el-form-item>
          <el-form-item label="QQ:" prop="qq">
            <el-input v-model="temp2.qq" style=""></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="mailAddress">
            <el-input v-model="temp2.mailAddress" style=""></el-input>
          </el-form-item>
          <el-form-item label="系别:" prop="department">
            <el-input v-model="temp2.department" style=""></el-input>
          </el-form-item>
          <el-form-item label="专业:" prop="specialty">
            <el-input v-model="temp2.specialty" style=""></el-input>
          </el-form-item>
          <el-form-item label="班级:" prop="classGrade">
            <el-input v-model="temp2.classGrade" style=""></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">保存</el-button>
      </div>
    </el-dialog>
    <!-- 导出 -->
    <el-dialog width="20%" v-dialogDrag title="导出excel" :close-on-click-modal='false' :visible.sync="dialogExcel">
      <div style="display: flex;justify-content: center;">
        <el-form :model="tempExcel" ref="tempExcel" :rules="rules" style="width: 90%;height: 120px;padding-top: 10px;">
          <el-form-item label="文件名称:" prop="fileName">
            <el-input v-model="tempExcel.fileName" style="width:217px"></el-input>
          </el-form-item>
          <el-form-item label="角色类型:" prop="roleType">
            <el-select v-model="tempExcel.roleType" placeholder="请选择" clearable>
              <el-option v-for="item in roleOptions" :key="item.roleName" :label="item.roleName" :value="item.roleName">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogExcel = false">取 消</el-button>
        <el-button type="primary" @click="leadingOut">保存</el-button>
      </div>
    </el-dialog>
    <!-- 导入实例图片 -->
    <el-dialog width="70%" v-dialogDrag title="导入excel示例" :close-on-click-modal='false' :visible.sync="dialogExcelRu">
      <div style="display: flex;" class="excel-daoru">
        <img src="../../assets/userList.png" alt="">
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogExcelRu = false">取 消</el-button>
        <el-button type="primary">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {findFilterUser,saveOwner,findRoleFile,findByUserProfilesId,deleteOwner,findByCardNum,ownerSaveExcel} from "../../api/zhongshanMeter";

  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {
      downloadTable,
      elIconBtn
    },
    data () {
      return {
        heights: document.getElementById('app').clientHeight-290,//屏幕高度 - 导航栏高度
        tempExcel: {
          fileName: "userList",
          state: 1
        },
        dialogExcel: false,//导出
        dialogExcelRu: false,//导入格式
        loading: true,

        //查看是否是删除还是未删除的列表
        chosenIndex: 1,
        statusList: [
          {
            name: '用户列表',
            id: 1
          },
          {
            name: '回收站',
            id: 0
          }
        ],
        //查询
        total: 0,
        currentPage: 1,
        currentSize: 10,
        form: {},
        //弹窗
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增用户",
          edit: "编辑用户"
        },
        //新增修改对象
        temp: {},
        password: "",
        temp2: {},
        //星号必填
        rules: {
          userName: [
            {required: true,message: '请输入姓名',trigger: 'blur'}
          ],
          userCode: [
            {required: true,message: '请输入登录名',trigger: 'blur'}
          ],
          identityCard: [
            {required: true,message: '请输入身份证',trigger: 'blur'}
          ]
        },
        //表格数据
        tableData: [],
        //表格选中
        multipleSelection: [],
        //角色类型
        roleOptions: [],
        roleType: "",
        update: false,//是否显示展开的表格
        sexList: [
          {
            label: "男",
            value: "男",
            id: 0
          },
          {
            label: "女",
            value: "女",
            id: 1
          },
        ],
        //查看身份证是否正确
        card_flag: false,
        iccardFlag: 0

      };
    },

    mounted () {
      //获取角色类型
      findRoleFile().then(res => {
        this.roleOptions=res.data
      })
      this.getList() //获取列表数据

    },
    computed: {

    },
    watch: {
      chosenIndex () {
        this.search()
      }
    },

    methods: {
      //搜索
      search () {
        this.form.pageIndex=this.currentPage
        this.form.pageSize=this.currentSize
        var obj=this.form
        for(let k in obj) {
          if(k,obj[k]=='') {
            Reflect.deleteProperty(obj,k)
          }
        }
        this.form.status=this.chosenIndex

        this.loading=true
        findFilterUser(this.form).then(res => {
          if(res.code==200) {
            res.data.content.forEach(item => {
              item.children=[]
            })
            this.tableData=res.data.content
            this.total=res.data.totalElements
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查询失败')
            this.loading=false
          }
        })
      },
      //身份证输入框、
      blur_fn () {
        var card=this.temp.identityCard
        // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X  
        var reg=/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(reg.test(card)===false) {
          this.card_flag=false
          this.$message({showClose: true,message: '身份证格式不正确！',type: 'error'});
          return false;
        }
        this.card_flag=true
        this.password=card.slice(-6)
      },
      // IC卡号
      iccardBlur_fn () {
        var id=this.temp.iccard
        if(id!=""&&id!=undefined) {
          findByCardNum({'cardNum': id}).then(res => {
            if(res.code==200) {
              if(res.data.state==1) {
                this.$message({showClose: true,message: '此卡号已经被绑定，请重新输入卡号！！！',type: 'error'});
              }
            } else {
              res.message? this.$message.error(res.message):this.$message.error('卡号错误，请重新输入！！！');
            }

          })
        }

      },
      //角色类型选择
      roleSelect (val) {
        var arr=this.roleOptions.filter(item => item.id==val)
        console.log(arr);
        this.roleType=arr[0].roleName

      },
      //表格选中
      handleSelectionChange (val) {
        this.multipleSelection=val;
      },
      //获取列表数据
      getList () {
        var d={
          'pageIndex': this.currentPage,
          'pageSize': this.currentSize,
          'status': 1,
        }
        this.loading=true
        findFilterUser(d).then(res => {
          if(res.code==200) {
            res.data.content.forEach(item => {
              item.children=[]
            })
            this.total=res.data.totalElements
            this.tableData=res.data.content
            this.loading=false
          } else {
            res.message? this.$message.error(res.message):this.$message.error('查看失败')
            this.loading=false
          }
        })
      },
      //按钮展开
      openmf (v,expandedRows) {
        if(v.children.length==0) {
          if(expandedRows.length>0) {
            findByUserProfilesId({'userProfilesId': v.userProfilesId}).then(res => {
              if(res.code==200) {
                v.children[0]=res.data
                this.update=false
                this.$nextTick(() => {
                  this.update=true
                })
              }
            })
          }
        } else {
          this.update=true
        }



      },
      //单个删除
      del_fn (row) {
        this.$confirm(`是否删除 ${row.userName}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteOwner({"id": row.userId}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //批量删除
      batchDel_fn () {
        var strId=""
        if(this.multipleSelection.length==0) {
          this.$message({showClose: true,message: '请勾选需要删除的用户',type: 'warning'});
          return
        }
        this.multipleSelection.forEach(item => {
          strId+=','+item.userId
        })
        this.$confirm(`是否批量删除已选中的用户列表`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteOwner({"id": strId.substr(1)}).then(res => {
            if(res.code==200) {
              this.getList();
              this.$message({showClose: true,message: '删除成功',type: 'success'});
            } else {
              res.message? this.$message.error(res.message):this.$message.error('删除失败');

            }
          })
        }).catch(() => {
          // ...
        });
      },
      //批量导入
      saveExcel_fn (file) {
        console.log(file);
        let data=new FormData();
        data.append("file",file.raw);
        this.loading=true
        ownerSaveExcel(data).then(res => {
          console.log("接口",res);
          if(res.code==200) {
            this.getList()
            this.$message({showClose: true,message: res.data,type: 'success'});
          } else {
            res.message? this.$message.error(res.message):this.$message.error('添加失败')

          }
        })
      },
      //导出
      leadingOut () {
        console.log("this.tempExcel.roleType",this.tempExcel.roleType);
        if(!this.tempExcel.roleType) {
          // DWSystemSetting.baseURL+
          window.open(DWSystemSetting.baseURL+'/owner/findExcel?fileName='+this.tempExcel.fileName+'&status='+this.tempExcel.state,"_blank");
          this.dialogExcel=false
          return
        }
        window.open(DWSystemSetting.baseURL+'/owner/findExcel?fileName='+this.tempExcel.fileName+'&roleType='+this.tempExcel.roleType+'&status=1',"_blank");
        this.dialogExcel=false

      },

      // 添加弹窗
      add_ed () {
        this.password=""
        this.iccardFlag=1
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.temp={}
        this.temp2={}
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
          this.$refs["temp2"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {
            this.temp.roleType=this.roleType
            this.temp.password=this.password
            var d={
              'ownerUserDTO': this.temp,
              'userProfilesDTO': this.temp2
            }
            if(!this.card_flag) {
              this.$message({showClose: true,message: '身份证格式不正确！',type: 'error'});
            } else {
              saveOwner(d).then(res => {
                if(res.code==200) {
                  this.getList();
                  this.dialogVisible=false;
                  this.$message({showClose: true,message: '添加成功',type: 'success'});
                } else {
                  res.message? this.$message.error(res.message):this.$message.error('删除失败');
                }
              })
            }


          } else {
            return false;
          }
        });
      },

      // 确认编辑
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {

            this.temp.roleType=this.roleType
            this.temp.password=this.password
            var data=this.temp
            //  if(!data.iccard){
            //     delete data.iccard
            //  }
            var d={
              "ownerUserDTO": data,
              "userProfilesDTO": this.temp2,
            }
            saveOwner(d).then(res => {
              if(res.code==200) {
                this.getList();
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                res.message? this.$message.error(res.message):this.$message.error(`${this.iccardFlag==0? '绑定失败':'修改'}失败`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v,type) {
        this.password=""
        this.iccardFlag=type
        if(this.iccardFlag==0) {
          this.textMap.edit='绑定IC卡'
        } else {
          this.textMap.edit='编辑用户'
        }
        this.dialogStatus='edit';

        this.temp=Object.assign({},v);
        this.password=v.password
        if(v.children.length==0) {
          findByUserProfilesId({'userProfilesId': v.userProfilesId}).then(res => {
            if(res.code==200) {
              v.children[0]=res.data
              this.temp2=res.data
            }
          })
        } else {
          this.temp2=v.children[0]
        }
        this.dialogVisible=true;

        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
          this.$refs["temp2"].clearValidate();
        });

      },
      //下载表格excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        const tHeader=[];
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-用户列表','.userList-table')
      },

      //分页功能
      newgetNowPageDataList () {
        // 当前页显示
        this.getList()
      },
      handleSizeChange (val) {
        this.currentSize=val;
        this.newgetNowPageDataList();
      },
      handleCurrentChange (val) {
        this.currentPage=val;
        this.newgetNowPageDataList();
      }


    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    }
  };
</script>
<style>
  .electricityBill .tableNest th {
    background-color: #f5f8fa !important;
    color: #999 !important;
  }

  .electricityBill .el-table__expanded-cell {
    background-color: #f5f8fa !important;
  }
</style>
<style lang="scss" scoped>
  .userList {
    padding: 8px;

    .content {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 20px;
      box-sizing: border-box;

      .userList-top {
        display: flex;
        justify-content: space-between;
        border-bottom: 2px solid #E6E6E6;
        padding-bottom: 12px;
        position: relative;

        /deep/.el-upload--picture-card {
          width: 100%;
          height: 32px;
          line-height: 32px;
          border: 0px;
        }

        .btns {
          display: flex;
          align-items: center;
        }

        .user-left {
          display: flex;

          // align-items: center;
          div {
            margin-right: 40px;
            font-size: 16px;
            cursor: pointer;
            color: #999999;

            &.active {
              color: #368ED9;
              font-weight: bold;
              //  border-bottom: 2px solid #368ED9;
            }
          }
        }

        .line {
          position: absolute;
          bottom: -1px;
          left: 0px;
          width: 56px;
          height: 2px;
          background-color: #368ED9;
          transition: 0.3s;

          &.active {
            left: 99px;
          }
        }



      }

      .search {
        display: flex;
        align-items: center;
        margin: 12px 0px 20px 0px;
        position: relative;
        left: -35px;

        /deep/.el-form-item {
          margin-bottom: 0px;
        }

        /deep/.el-input__inner {
          max-width: 2rem;
        }
      }

      .userList-table {
        /deep/.el-table th {
          background-color: #F3F8FF;
          color: #999999;
          border-right: 1px solid #E6E6E6;
          padding: 10px 0px;
          font-weight: bold;
        }

        /deep/.el-table td {
          padding: 1px 0px;
        }

        /deep/.el-table th.is-leaf {
          border-bottom: 0px;
        }

        .status {
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 50%;
          position: relative;
          top: -1px;
        }

        .blue {
          background-color: #52A1FF;

        }

        .ash {
          background-color: #999999;

        }

        /deep/.el-table__expanded-cell {
          border-bottom: 0px !important;

        }

        /deep/ td {
          height: 44px;
        }

        .buttoned_box {
          display: flex;
          justify-content: center;
          align-items: center;

          .line {
            display: inline-block;
            min-width: 1px;
            height: 20px;
            background-color: #E6E6E6;
            margin: 0px 10px;
          }

          .buttoned {
            cursor: pointer;
          }

          /deep/.el-button span {
            font-size: 15px;
            font-weight: 400;
          }
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }

    }

    /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

    .dialog-form {
      display: flex;

      /deep/ .el-form-item__content {
        width: 202px;
      }


      .demo-temp {
        display: flex;
        flex-wrap: wrap;
      }

      /deep/.el-form-item {
        display: flex;
        margin-left: 20px;
        margin-bottom: 15px;
      }

      /deep/ .el-form-item__label {
        white-space: nowrap;
        width: 70px;
      }

      /deep/.el-dialog__body {
        padding: 20px 0px 0px 20px !important;
      }
    }

    .excel-daoru {
      img {
        width: 100%;
        height: 100%;
      }
    }


  }
</style>